import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitLead = (data) => axios.post(`${API}/leads`, data).then((r) => r.data);
export const submitContact = (data) => axios.post(`${API}/contact`, data).then((r) => r.data);
